import Tip, {TipType} from '../../../ui/Tip';
import LanguageFilter from './LanguageFilter';
import InstructionSection from '../InstructionSection';
import React from 'react';
import {LanguageId} from '../../../models/utils/Languages';
import FormView from '../../../models/form/FormView';
import ReadOnlySection from './ReadOnlySection';

type ReadOnlyFormProps = {
  language: LanguageId
  setLanguage: (lang: LanguageId) => void
  withInstructions: boolean
  instructions?: string
  view: () => FormView
}

export default function ReadOnlyForm({language, setLanguage, withInstructions, instructions, view}: ReadOnlyFormProps) {
  return (
    <>
      <div className="max-w-screen-md mb-5">
        <Tip type={TipType.Info}>
          This form configuration is in read-only mode due to limitations imposed by Management 3.0. You can review
          its content, but you are not allowed to change it in any way.
        </Tip>
        <div className="pt-4">
          <h2 className="text-2xl pb-3 flex justify-between">
            <span className="font-bold">Form Template</span>
            <LanguageFilter setSelectedLanguage={(lang) => setLanguage(lang)}
              selectedLanguage={language}/>
          </h2>
          {withInstructions &&
          <InstructionSection instructions={instructions} onChange={() => false}/>
          }
          {view().selectedSections.map((section) =>
            <ReadOnlySection section={section} key={section.id}/>)
          }
        </div>
      </div>
      <div className="pb-28 text-base"/>
    </>
  );
}
